import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'jf-hillebrand-to-integrate-linescape-into-tms',
  template: require('./jf-hillebrand-to-integrate-linescape-into-tms.html'),
  styles: [require('./../blog.component.scss'), require('./jf-hillebrand-to-integrate-linescape-into-tms.scss')]
})
export class JfHillebrandToIntegrateLinescapeIntoTms extends BlogPage {
  title = "JF Hillebrand to integrate Linescape’s Sailing Schedules into TMS";
  description = "JF Hillebrand, a Netherlands-based provider of high quality door to door service for shipping wines, has integrated Linescape’s Sailing Schedules into their TMS in order to improve customer experience.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/jf-hillebrand-to-integrate-linescape-into-tms/jf-hillebrand-to-integrate-linescape-into-tms.ts